<div class="row" *ngIf="!isCombinedReport">
<div class="col-12  border-line-b">
  <div class="section-header m-t-20 m-b-15">
    {{ 'lang.reporting.reportDescriptionTitle' | translate }}:
  </div>
  <div class="lh-1-4 detailed-description" innerHTML="{{'lang.reporting.individualReportDescription' | translate}}">
  </div>
</div>
</div>
<div class="row">
  <div class="col-12 common-heading" [ngSwitch]="isCombinedReport">
    <div *ngSwitchCase="true" class="section-header m-t-20 m-b-15">{{ 'lang.reporting.combinedReportingTitle' | translate }}</div>
    <div *ngSwitchCase="false" class="section-header m-t-20 m-b-15">{{ 'lang.reporting.detailedReportingTitle' | translate }}</div>
  </div>
  <div class="col-7 lh-1-4 detailed-description" [ngSwitch]="isCombinedReport">
    <span *ngSwitchCase="true" innerHtml="{{ 'lang.reporting.combinedReportingDescription' | translate }}"></span>
    <span *ngSwitchCase="false" innerHtml="{{ 'lang.reporting.detailedReportingDescription' | translate }}"></span>
  </div>
  <div class="col-5">
    <div class="mb-1">
      <span class="legend assessing-you"></span>
      <span>{{'lang.reporting.assessingOther' | translate}}</span> </div>
    <div *ngIf="!isCombinedReport" class="mb-1"> 
      <span class="legend assessing-yourself"></span>
      <span>{{'lang.reporting.evaluationYourself' | translate}}</span>
    </div>
    <div *ngIf="!isCombinedReport" class="mb-1"> 
      <span class="legend comparison-group"></span>
      <span>{{'lang.reporting.participantCategoryComparisonGroup' | translate}}</span>
    </div>
  </div>
  </div>